import { Component, HostListener } from '@angular/core';
import { SubSink } from 'subsink';
import { AppComponent } from '../../../../app.component';
import { AppMainComponent } from '../../component/main-panel/app.main.component';
import { AdministrationService, INavigationData, NavigationService } from '../../service';
import { CommonService } from '../../service/common/common.service';
import {  Observable, Subscription } from 'rxjs';
import { Settings } from '../../lib/app.constant';
import { environment } from 'src/environments/environment';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FilterService } from '../../service/filter/filter.service';
import { MessageService } from 'primeng/api';
import { MsalService } from '@azure/msal-angular';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-360deg)' })),
      transition('rotated => default', animate('2000ms ease-out')),
      transition('default => rotated', animate('2000ms ease-in'))
    ])
  ]
})
export class AppTopBarComponent {
  isUnreadAnnouncement=true;
  environment = environment;
  showAnnouncement: boolean = false;
  timeoutId: any;
  private subscription = new SubSink();
  currentNav: INavigationData = null;
  public viewInfo: string = "Dashboard";
  public menuTitle: string = "";
  public userDetails: any;
  rotateState: string = 'default';
  showReordering: boolean = false;
  logoClass: string;
  logoEnvironment: string;
  firstLetter: any;
  displaySearch: boolean = false;
  position: any;
  displayColSetting: boolean;
  schema: any[] = [];
  selectedColumns = []
  preferenceId: any;
  columnTemplateId: any;
  preferenceListColumnSettings: any;
  logoutConfirmation: boolean = false;
  filterListData: any;
  isFilter: boolean;
  announcementList: any;
  notificationList: any;
  notificationCount: any;
  queueCountObject: any={};
  emailInboxCount: any;
  documentTypeList: any;
  sftpFilesData: any=[];
  privilegeList: any;
  userDetails$:Observable<any>;

  constructor(private store: Store<any>,public adminService:AdministrationService,public appMain: AppMainComponent, public app: AppComponent, private navigationService: NavigationService, private refreshService: CommonService, private filterService: FilterService, public route: Router, private messageService: MessageService, private msalAuthService: MsalService,) {
    this.userDetails$ = this.store.pipe(select(state => state?.list?.data?.profile));
  }
  ngOnInit() {
    this.getUserJSONDetails();
    this.subscription.add(
      this.navigationService.$currentNav.subscribe(
        (selectedNav: INavigationData) => {
          if (selectedNav) {
            this.displaySearch = false;
            this.currentNav = selectedNav;
            switch (this.currentNav.routeType) {
              case 0: {
                this.viewInfo = "DASHBOARD ";
                this.menuTitle = "";
                break;
              }
              case 1: {
                this.viewInfo = "RECORD TRACKER";
                this.menuTitle = "";
                break;
              }
              case 2: {
                this.viewInfo = "RECORD TRACKER VIEW";
                this.menuTitle = "";
                break;
              }
              case 3: {
                this.viewInfo = "VIEW SUPPLIER DETAILS";
                this.menuTitle = "";
                break;
              }
              case 4: {
                this.viewInfo = "USER PROFILE";
                this.menuTitle = "";
                break;
              }
              case 9: {
                this.viewInfo = "CREATE SUPPLIER";
                this.menuTitle = "";
                break;
              }
                case 8: {
                this.viewInfo = "CREATE SUPPLIER";
                this.menuTitle = "";
                break;
              }
              case 22: {
                this.viewInfo = "D365 DATABASE";
                this.menuTitle = "Master Data";
                break;
              }
              case 5: {
                this.viewInfo = "UPDATE SUPPLIER";
                this.menuTitle = "";
                break;
              }
              case 31: {
                this.viewInfo = "MODIFY SUPPLIER";
                this.menuTitle = "";
                break;
              }
              case 10: {
                this.viewInfo = "LEGAL ENTITY";
                this.menuTitle = "Master Data";
                break;
              }
               case 29: {
                this.viewInfo = "GLOBAL FIELDS CONFIGURATION";
                this.menuTitle = "Master Data";
                break;
              }
              case 72: {
                this.viewInfo = "LE-BU RELATIONSHIP";
                this.menuTitle = "Master Data";
                break;
              }
              case 73: {
                this.viewInfo = "SERTICA UNIT-D365 LE CONFIGURATION";
                this.menuTitle = "Master Data";
                break;
              }
              case 11: {
                this.viewInfo = "COUNTRY";
                this.menuTitle = "Master Data";
                break;
              }
              case 12: {
                this.viewInfo = "CURRENCY";
                this.menuTitle = "Master Data";
                break;
              }
              case 79: {
                this.viewInfo = "STATUS";
                this.menuTitle = "Administration";
                break;
              }
               case 80: {
                this.viewInfo = "SLA";
                this.menuTitle = "Administration";
                break;
              }
              case 13: {
                this.viewInfo = "SALES TAX GROUPS";
                this.menuTitle = "Master Data";
                break;
              }
              case 14: {
                this.viewInfo = "GROUP PROCUREMENT APPROVERS";
                this.menuTitle = "Master Data";
                break;
              }
              case 78: {
                this.viewInfo = "ERROR CODE LIST";
                this.menuTitle = "Master Data";
                break;
              }
              case 16: {
                this.viewInfo = "Reason Codes";
                this.menuTitle = "Master Data";
                break;
              }
              case 17: {
                this.viewInfo = "METHOD OF PAYMENT";
                this.menuTitle = "Master Data";
                break;
              }
              case 18: {
                this.viewInfo = "VELOCITY FORM INPUT FIELDS";
                this.menuTitle = "Master Data";
                break;
              }
              case 19: {
                this.viewInfo = "SERTICA FORM INPUT FIELDS";
                this.menuTitle = "Master Data";
                break;
              }
              case 25: {
                this.viewInfo = "VELOCITY ORGANISATION CONFIGURATION TABLE";
                this.menuTitle = "Master Data";
                break;
              }
              case 26: {
                this.viewInfo = "SERTICA UNITS CONFIGURATION TABLE";
                this.menuTitle = "Master Data";
                break;
              }
              case 27: {
                this.viewInfo = "LS RETAIL FORM INPUT FIELDS";
                this.menuTitle = "Master Data";
                break;
              }
              case 99: {
                this.viewInfo = "SUPPLIER CHANGE LOG";
                this.menuTitle = "Master Data";
                break;
              }
              case 106: {
                this.viewInfo = "D365 MD CHANGE LOG";
                this.menuTitle = "Master Data";
                break;
              }
              case 28: {
                this.viewInfo = "TERMS OF PAYMENT";
                this.menuTitle = "Master Data";
                break;
              }
              case 101: {
                this.viewInfo = "SERTICA DATABASE";
                this.menuTitle = "Master Data";
                break;
              }
              case 102: {
                this.viewInfo = "VELOCITY DATABASE";
                this.menuTitle = "Master Data";
                break;
              }
              case 103: {
                this.viewInfo = "LSRETAIL DATABASE";
                this.menuTitle = "Master Data";
                break;
              }
               case 114: {
                this.viewInfo = "SPECIAL LOB DATABASE";
                this.menuTitle = "Master Data";
                break;
              }
               case 115: {
                this.viewInfo = "OTHER";
                this.menuTitle = "OTHER REQUESTS";
                break;
              }
               case 116: {
                this.viewInfo = "BULK BLOCK/UPDATE REQUESTS";
                this.menuTitle = "OTHER REQUESTS";
                break;
              }
               case 117: {
                this.viewInfo = "CREATE/UPDATE EMPLOYEE VENDOR";
                this.menuTitle = "OTHER REQUESTS";
                break;
              }
                 case 118: {
                this.viewInfo = "EXTEND TO LOB";
                this.menuTitle = "OTHER REQUESTS";
                break;
              }
               case 113: {
                this.viewInfo = "CONTACT INFORMATION PURPOSE";
                this.menuTitle = "Master Data";
                break;
              }
              case 20: {
                this.viewInfo = "USER MANAGEMENT";
                this.menuTitle = "Administration";
                break;
              }
              case 21: {
                this.viewInfo = "ROLE MANAGEMENT";
                this.menuTitle = "Administration";
                break;
              }
              case 23: {
                this.viewInfo = "COLUMN SETINGS";
                this.menuTitle = "Administration";
                break;
              }
              case 66: {
                this.viewInfo = "SALES TAX GROUP SCRIPTS";
                this.menuTitle = "Administration";
                break;
              }
              case 107: {
                this.viewInfo = "EMAIL LOG";
                this.menuTitle = "Administration";
                break;
              }
              case 67: {
                this.viewInfo = "METHOD OF PAYMENT SCRIPTS";
                this.menuTitle = "Administration";
                break;
              }
              case 68: {
                this.viewInfo = "VELOCITY SCRIPTS";
                this.menuTitle = "Administration";
                break;
              }
              case 69: {
                this.viewInfo = "FIELD USAGE ACROSS THE SYSTEMS CONFIG";
                this.menuTitle = "Administration";
                break;
              }
              case 35: {
                this.viewInfo = "ANNOUNCEMENT";
                this.menuTitle = "Administration";
                break;
              }
               case 6: {
                this.viewInfo = "MANUAL EMAIL TEMPLATE";
                this.menuTitle = "Administration";
                break;
              }
              case 7: {
                this.viewInfo = "AUTO EMAIL TEMPLATE";
                this.menuTitle = "Administration";
                break;
              }
              case 109: {
                this.viewInfo = "EMAIL TEMPLATE CONTROLLER";
                this.menuTitle = "Administration";
                break;
              }
              case 65: {
                this.viewInfo = "USER ACTIVITY LOGS";
                this.menuTitle = "Administration";
                break;
              }
              case 104: {
                this.viewInfo = "APPLICATION CONFIGURATION";
                this.menuTitle = "Administration";
                break;
              }
              case 111: {
                this.viewInfo = "NOTIFICATION LOG";
                this.menuTitle = "Administration";
                break;
              }
              case 110: {
                this.viewInfo = "UPDATE REQUEST LOG";
                this.menuTitle = "Administration";
                break;
              }
                case 112: {
                this.viewInfo = "INTRODUCTION TO ASTRO";
                this.menuTitle = "";
                break;
              }
            }
          }
        }
      ),
    );
    this.userDetails$.subscribe(data => {
      this.userDetails=data;
      this.userDetails = {
        ...data,
        first_name: data?.first_name && data?.first_name !== '' ? data?.first_name : 'Astro',
        last_name: data?.last_name && data?.last_name !== '' ? data?.last_name : 'User',
      };
      this.firstLetter = this.getFirstLetter(this.userDetails?.first_name, this.userDetails?.last_name);
      this.isUnreadAnnouncement=data?.announcement_read_flag;
    });
    this.logoClass = Settings.EnvironmentType[environment.environmentType].toLowerCase();
    this.logoEnvironment = Settings.EnvironmentType[environment.environmentType];
    this.initTimer();
  }

  get showRefreshButton():boolean{
   const paths = [
  'user/supplier/create',
  'user/supplier/reopen',
  'user/modify-supplier',
  'user/master-data/supplier-view',
  'user/other-requests'
  ];
  const showRefresh = paths.some(path => this.route?.url?.includes(path));
  return !showRefresh;
  }
  onClickShowMails(action){
    this.route.navigate([]).then(result => { window.open(`user/email-tracker/email-log/${action}`, '_blank'); });
  }
  getFirstLetter(first, last) {
    const str = first + " " + last
    let firstLetters = str
      .split(' ')
      .map(word => word[0])
      .join('');
    return firstLetters;
  }

  onClickNavigateToProfilePage() {
    this.route.navigate(['/user/profile/overview']);
  }
  refreshGrid() {
    this.sendRefreshClickEvent();
    this.resetTimer();
  }
  resetTimer() {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => this.refreshGrid(), Settings.AutoRefreshTime.refreshTimeInMilliSeconds); // 30 seconds
  }
  displaySearchDialog(pos) {
    this.position = pos;
    this.displaySearch = true;
  }
  @HostListener('window:keydown', ['$event'])
  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:mousedown', ['$event'])
  @HostListener('window:touchstart', ['$event'])
  @HostListener('window:touchmove', ['$event'])
  @HostListener('window:visibilitychange')
  onActivity() {
    this.resetTimer();
  }

  initTimer() {
    this.onActivity();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Check if the shortcut key combination is pressed
    if (event.ctrlKey && event.key === 'r') {
      event.preventDefault(); // Prevent default browser behavior (refreshing the page)
      this.sendRefreshClickEvent(); // Call your function
    }
  }
  getNotificationCount(){
    this.refreshService.getNotificationCount().subscribe({
      next:(res)=>{
        this.notificationCount=res?.count;
      },
      error:()=>{

      }
    })
  }
  getNotificationList(){
    this.refreshService.getNotificationList().subscribe({
      next:(res)=>{
       this.notificationList=res?.results;
       this.notificationList=this.notificationList.map((el:any)=>{
        el.notificationType=Settings.NotificationType[el?.notificationTypeId];
        return el;
       })
      },
      error:()=>{

      }
    })
  }
  onClickNavigateToNotification(id="all",notificationType=null,action=null){
   let body={
      "keys":id,
      "clear":false
    }
    this.refreshService.postNotificationRead(body).subscribe({
      next:(res)=>{
        if(action){
          if(action.includes(",")){
           let actionArray= action?.split(",")
            if(notificationType?.includes('DOCTRACKER'))
            this.filterService.sendFilterData([this.route.url, {
              transId: actionArray,isFilter:true}])
          }
          else{
      }
          }
      this.getNotificationCount();
      },
      error:()=>{

      }
    })
  }
  onClickClearNotification(id="all"){
    let body={
      "keys":id,
      "clear":true
    }
    this.refreshService.postNotificationRead(body).subscribe({
      next:(res)=>{
      this.getNotificationCount();
      this.getNotificationList();
      },
      error:()=>{

      }
    })
  }
  rotate() {
    this.rotateState = (this.rotateState === 'default' ? 'rotated' : 'default');
  }
  sendRefreshClickEvent() {
    this.rotate();
    this.refreshService.onClickSendRefreshEvent(this.currentNav.route);
  }
  openHandbook(){
    this.messageService.add({
      severity: 'success',
      key: 'emptyToster',
      summary: 'Please Wait',
      detail: 'Astro Handbook will open shortly in a new tab.'
    });
   this.refreshService.getAstroHandbook().subscribe({
  next:(res)=>{
  let url = CommonService.generateFileUrl(res?.file_data,res?.file_name??"AstroHandbook.pdf");
  CommonService.openFileInNewTab(url);
  },
  error:()=>{
    this.messageService.add({
      severity: 'error',
      key: 'emptyToster',
      summary: 'No File View',
      detail: 'Due to some reason, Astro Handbook View Failed. Please Try Again Later.'
    });
  }
})
  }

  sendFilterReset(){
    this.filterService.sendClearFilterEvent(false);
  }
  async logOut() {
    this.logoutConfirmation = false;
    this.msalAuthService.logoutRedirect();
  }
  onClickShowAnnouncement() {
    this.getAnnouncementList();
  }
  getAnnouncementList(){
    let body={page:1,page_size:100}
    this.refreshService.getAnnouncementList(body).subscribe({
      next: (res: any) => {
          this.announcementList = res?.results;
          this.showAnnouncement = true;
          if(!this.isUnreadAnnouncement){
            this.getProfileDetails();
       }
      },
      error: (error) => {
      }
    })
  }
  downloadPDF(base64Data: string,fileName:string, id): void {

      this.adminService.getAnnouncementFile(id).subscribe({
          next: (res: any) => {
              const base64 = res.file_content;
              const binaryData = atob(base64);
              const arrayBuffer = new ArrayBuffer(binaryData.length);
              const byteArray = new Uint8Array(arrayBuffer);
              for (let i = 0; i < binaryData.length; i++) {
                  byteArray[i] = binaryData.charCodeAt(i);
              }
              const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = fileName; // Specify the desired file name here
              link.click();
              // Clean up the URL object
              window.URL.revokeObjectURL(url);
          }
      })
  }

  getUserJSONDetails() {
    this.refreshService.getUserListJSONDetails().subscribe({
      next: (res) => {
       this.filterService.sendUserDetailsJSON(res);
       localStorage.setItem('userNameDetails',JSON.stringify(res))
      },
      error: () => {

      }
    })
  }
  getProfileDetails() {
    this.refreshService.getProfileDetails().subscribe({
      next: (res) => {
        localStorage.setItem('userDetails', JSON.stringify(res));
        this.userDetails = res;
        this.userDetails.first_name=this.userDetails.first_name && this.userDetails.first_name!=''?this.userDetails.first_name:'Astro';
        this.userDetails.last_name=this.userDetails.last_name && this.userDetails.last_name!=''?this.userDetails.last_name:'User';
        this.firstLetter = this.getFirstLetter(this.userDetails?.first_name, this.userDetails?.last_name);
        this.isUnreadAnnouncement=res?.announcement_read_flag;
      },
      error: () => {

      }
    })
  }

  ngOnDestroy() {
  }
}
